import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Grid, IconButton} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import ActiveButton from "./ActiveButton";
import TrashIcon from "../../../../components/icons/TrashIcon";
import EditIcon from "../../../../components/icons/EditIcon";
import moment from "moment";
import {greyishBlue500} from "../../../../assets/jss/main";
import BeatLoaderRegular from "../../../../components/loaders/BeatLoaderRegular";
import {MissionModelListContext} from "../MissionModelListContext";

ModelItem.propTypes = {
    missionModel: PropTypes.object.isRequired,
};

function ModelItem({missionModel}) {
    const {
        loading,
        handleEditeMissionModel,
        handleOpenDeleteMissionModelModal
    } = useContext(MissionModelListContext)

    return (
        <TableRow>
            <TableCell>
                {missionModel.name}
            </TableCell>
            <TableCell>
                <ActiveButton
                    missionModel={missionModel}
                />
            </TableCell>
            <TableCell>
                {moment(missionModel.createdAt || missionModel.updatedAt).format('DD/MM/YYYY') || " - "}
            </TableCell>
            <TableCell>
                <Grid item sx={{width: '80px'}}>
                    {loading && (
                        <Grid container justifyContent={"start"}>
                            <BeatLoaderRegular loading={true} size={10} />
                        </Grid>
                    )}

                    {!loading && (
                        <Grid item container justifyContent={"start"}>
                            <IconButton onMouseDown={() => {
                                handleEditeMissionModel(missionModel)
                            }}>
                                <EditIcon size={16}/>
                            </IconButton>
                            <IconButton onMouseDown={() => {
                                handleOpenDeleteMissionModelModal(missionModel)
                            }}>
                                <TrashIcon color={greyishBlue500} size={18}/>
                            </IconButton>
                        </Grid>
                    )}
                </Grid>
            </TableCell>
        </TableRow>
    )
}

export default ModelItem;